(function () {
  const tabs = document.getElementById('pills-tab');
  const tabItems = tabs && tabs.querySelectorAll('.pill-link');
  const tabContent = document.getElementById('pills-tab-content');

  if (!tabItems) return;

  tabItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();

      const target = event.target.getAttribute('href');
      const content = tabContent.querySelector(target);
      const activeTab = tabs.querySelector('.active');
      const activeContent = tabContent.querySelector('.active');

      activeTab.classList.remove('active');
      activeContent.classList.remove('active');

      item.classList.add('active');
      content.classList.add('active');
    });
  });
})();